import React from 'react'
import styles from './FeedbackModal.module.css'

const InfoCard = ({ icon: Icon, label, content, className }) => {
  return (
    <div className={`${styles.infoCard} ${className || ''}`}>
      <Icon className={styles.infoIcon} />
      <div>
        <strong>{label}:</strong> {content}
      </div>
    </div>
  )
}

export default InfoCard
